module.exports = __webpack_public_path__ + "img/verified-check.1168aba2.svg";